import React, { useState, useEffect } from "react";
import { css } from "emotion";
import Loading from "../../../../../../shared/Loading/Loading";
import EditFidelityProgramDetails from "./EditFidelityProgramDetails";
import EditBankDetails from "./EditBankDetails";
import LatamPhoneWarning from "../../../shared/LatamPhoneWarning";

import { loadingStyle, editFidelityAndBank, latamWarningContainer } from "./style";
import { useNewOffer } from "../../../../../context/new-offer";
import { returnUserJWT, uuid } from "../../../../../shared/utils";

const StepEditFidelityAndBank = props => {
	const [state, setState] = useState({
		inputInFocus: ""
	});

	const {
		userData,
		bankData,
		loyaltyData,
		setBankData,
		setLoyaltyData,
		rankingData,
		banks,
		newOfferTempData,
		setNewOfferTempData,
		participantData,
		acceptanceTerms,
		setAcceptanceTerms,
		phoneMultiplus,
		airlineProgramsSettings,
		status2FAEnabledFeature,
		email2FAStatusValidation,
		offerData,
		request2FACodeLatam,
		uuidCybersource,
		setUuidCybersource,
		hasClickedRequest2FACode,
		setHasClickedRequest2FACode,
		twoFactorData,
		hasTriedToProceedWithout2FA
	} = useNewOffer();

	const setInputInFocus = component => {
		let temp = {
			...state,
			inputInFocus: component
		};

		setState(temp);
	};

	const setLoyaltyDataFn = data => {
		setLoyaltyData({
			...loyaltyData,
			data: { ...loyaltyData.data, ...data }
		});
	};

	const setBankDataFn = data => {
		const cpfcnpj = returnUserJWT().ssn.replace(/[^0-9]/g, "");

		setBankData({
			...bankData,
			data: { ...bankData.data, ...data, cpfcnpj }
		});
	};

	const checkData = (box, value) => {
		setNewOfferTempData({
			...newOfferTempData,
			form: {
				...newOfferTempData.form,
				[box]: value
			}
		});
	};

	useEffect(() => {
		if (uuidCybersource) return;
		setUuidCybersource(uuid());
	}, [uuidCybersource]);

	return userData.isFetching || rankingData.isFetching ? (
		<div
			className={css`
				${loadingStyle};
			`}
		>
			<Loading width={120} height={120} />
		</div>
	) : (
		<div
			className={css`
				${editFidelityAndBank}
			`}
		>
			<div className="row">
				<div className="col-xs-16">
					{twoFactorData.is2FAEnabled ? null : (
						<EditFidelityProgramDetails
							checkData={props.checkData || checkData}
							inputInFocus={state.inputInFocus}
							setData={setLoyaltyDataFn}
							setInputInFocus={setInputInFocus}
							fidelityProgram={props.currentProgram}
							userData={loyaltyData.data}
							phoneMMSuggestion={phoneMultiplus}
							typePhoneLatam={props.typePhoneLatam}
							airlineProgramsSettings={airlineProgramsSettings}
							status2FAEnabledFeature={status2FAEnabledFeature}
							email2FAStatusValidation={email2FAStatusValidation}
							offerData={offerData}
							request2FACodeLatam={request2FACodeLatam}
							hasClickedRequest2FACode={hasClickedRequest2FACode}
							setHasClickedRequest2FACode={setHasClickedRequest2FACode}
							twoFactorData={twoFactorData}
							hasTriedToProceedWithout2FA={hasTriedToProceedWithout2FA}
						/>
					)}

					{!participantData.hasManagementActive && (
						<EditBankDetails
							checkData={props.checkData || checkData}
							options={banks.data}
							setInputInFocus={setInputInFocus}
							setData={setBankDataFn}
							bankData={bankData.data}
							setAcceptanceTerms={setAcceptanceTerms}
							acceptanceTerms={acceptanceTerms}
						/>
					)}
				</div>

				{props.currentProgram.id === 3 && props.typePhoneLatam !== 1 && (
					<div
						className={css`
							${latamWarningContainer}
						`}
					>
						<LatamPhoneWarning phoneMultiplus={phoneMultiplus} />
					</div>
				)}
			</div>
		</div>
	);
};

export default StepEditFidelityAndBank;
